module.exports = __webpack_public_path__ + "img/product-1-thumb-10.e2778b0d.jpg";